(() => {
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('button.AOV-CartDrawer-Checkout')
      : null;
    const checkout = window.__GetCheckout;
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (!checkout?.active || typeof checkout.toCheckout !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.toCheckout();
  }, true);

  const settings = window.AVADA_CART_DRAWER?.settings;
  if (!settings) return;

  settings.cartNumberSelector = '.ark-woo-cart-contents';
  settings.cartIconSelector = '.woo_amc_open_active';

  if (settings.contentSettings?.footer) {
    settings.contentSettings.footer.redirectToCart = false;
  }
})();
